import { useTranslation } from 'react-i18next';
import { gogLink } from '../lib/affiliate';

function GameCard({ item, onExplain }) {
  const { t } = useTranslation();
  const hours = Math.round((item.playtimeMinutes || 0) / 60);
  // Jaquette Steam par App ID (header.jpg, dispo pour la quasi-totalité des jeux).
  const cover = `https://cdn.cloudflare.steamstatic.com/steam/apps/${item.appId}/header.jpg`;

  const open = () => onExplain && onExplain(item);

  return (
    <article
      className={`game-card game-card--${item.riskType}`}
      onClick={open}
      role="button"
      tabIndex={0}
      title={t('catinfo.explain')}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      }}
    >
      <div className="game-card__cover">
        <img
          src={cover}
          alt={item.name || ''}
          loading="lazy"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <div className="game-card__badges">
          <span className={`risk-badge risk-badge--${item.riskType}`}>
            {t(`risk.${item.riskType}`)}
          </span>
          {/* "Sauvable" n'a de sens que pour un jeu EN DANGER récupérable sur GOG. */}
          {item.savable && item.riskType !== 'safe' && (
            <span className="save-badge">{t('verdict.savable')}</span>
          )}
        </div>
      </div>

      <div className="game-card__body">
        <h3 className="game-card__name">{item.name}</h3>
        {item.notes && <p className="game-card__notes">{item.notes}</p>}

        <div className="game-card__foot">
          {hours > 0 && (
            <span className="game-card__playtime">{t('verdict.playtime', { hours })}</span>
          )}
          {item.savable && (
            <a
              className="game-card__gog"
              href={gogLink(item.gogUrl)}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              GOG →
            </a>
          )}
        </div>
      </div>
    </article>
  );
}

export default GameCard;
